module.exports = __webpack_public_path__ + "static/img/wx.4358a53c.png";